<template>
  <div class="sn-f-c-c app-footer">
    <div class="sn-f-c-s footer" v-if="$sn.utils.getHospitalId() === perpetual.HOSPITAL_ID_SDSL" :class="perpetual.HOSPITAL_ID_SDSL">
      <div class="logo" :style="{'background-image': 'url(' + ALI_CLOUD_DOMAIN_STATIC + '/hos/ui/images/pc/footer/line.png)'}">
        <img :src="ALI_CLOUD_DOMAIN_STATIC + '/hos/ui/images/pc/footer/1-' + perpetual.HOSPITAL_ID_SDSL + '.png'">
      </div>
      <div class="sn-f-c-c">
        <img class="institution" :src="ALI_CLOUD_DOMAIN_STATIC + '/hos/ui/images/pc/footer/2-' + perpetual.HOSPITAL_ID_SDSL + '.png'">
        <div>
          <div class="caption">山东省立医院版权所有 Copyrights © 2009 sph.com.cn All Rights Reserved</div>
          <div class="caption">山东省立医院总机：0531-87938911 山东省立医院地址：济南市经五纬七路324号 邮编：250021</div>
          <div class="caption">ICP备案：鲁ICP备11002409号 技术支持：山东顺能网络科技有限公司</div>
          <div class="caption">工信部链接：http://www.miitbeian.gov.cn</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import self from '@/common/utils/global-config';
import * as Constants from '@/common/utils/constants';

export default {
  name: 'app-footer',
  data() {
    return {
      ALI_CLOUD_DOMAIN_STATIC: self.$sn.constants.ALI_CLOUD_DOMAIN_STATIC,
      perpetual: Constants
    };
  }
};
</script>
<style lang="scss" scoped>
.app-footer {
  @include fs(14);

  overflow: hidden;
  width: 100%;
  color: $white;

  .footer {
    overflow: hidden;
    width: 100%;
    padding: 20px 0;

    .logo {
      overflow: hidden;
      background-repeat: no-repeat;
      background-position: right center;
      padding-right: 20px;
      margin-right: 20px;
    }

    .institution {
      width: 85px;
      height: auto;
      margin-right: 20px;
    }

    .caption {
      margin-bottom: 10px;
    }

    &.SDSL2015 {
      background-color: $main1;

      .logo {
        img {
          width: 340px;
          height: auto;
        }
      }
    }
  }
}
</style>
